<div class="note-tab-block">
    <!-- <p class="text-14-400 color-8 mb-0 ri-py-2 ri-px-4 text-center bg-26">{{ ss.t('trash_itemEraseContent') }}</p> -->
    <div class="note-trash-block ri-px-4 ri-pt-4 ri-bb-1 entity-block" *ngFor="let entity of deletedNotes(); let i = index; trackBy: trackByEntity;">
        <app-note-block [noteId]="entity.entityId" [show]="show"></app-note-block>
        <div class="flex items-center justify-around ri-pt-1">
            <button class="btn-text text-16-400 color-11 ri-px-8 ri-py-4" (click)="remove(entity.entityId)">{{
                ss.t('common_buttonRemove') }}</button>
            <button class="btn-text text-14-400 color-35 ri-px-8 ri-py-4" (click)="restore(entity.entityId)">{{
                ss.t('common_restore') }}</button>
        </div>
    </div>

    <div class="no-result-block h-full flex items-center justify-center flex-col" *ngIf="deletedNotes().length === 0">
        <app-svg [name]="'notePlaceholder'" [color]="ss.theme().color1"></app-svg>
        <p class="text-16-400 color-8 mb-0 ri-pt-4">{{ ss.t('common_noNotes') }}</p>
    </div>
</div>